import { NgModule } from '@angular/core';
//import { Debounce } from 'angular2-debounce';

@NgModule({
    //declarations: [Debounce],
    //exports: [Debounce]
})
export class DebounceModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/debounce/debounce.module.ts